query allSelectionParameters(
  $filter: SelectionParameterFilter,
  ) {
  allSelectionParameters(
    filter: $filter
  ) {
    nodes {
      name
      code
      sport
    }
  }
}
